import React, { Component, Fragment } from 'react';
import Pagination from '@mui/material/Pagination';
import { FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import moment from 'moment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import Loading from '../../common/loading';
import { isEmpty, isNull, isUndefined, setHour } from '../../utility';

export default class FormFiltersDeviceAccess extends Component {
    constructor(props) {
        super(props);
        this.state = {

            fieldOrder: '',
            numberDevice: '25',
            currentNumberPage: '1',
            typeOrder: '',

            filterText: '',

            filterCreatedAtStart: dayjs(moment().subtract(1, 'day').toDate()),
            filterCreatedAtEnd: dayjs(moment().toDate()),

            filterMinUa: 1,
            filterMinIp: 1,
            filterMinDevices: 5,

            page: 1,
            modal: false,
            changeNumberPage: false,
            moreItems: false,
            newTotalPages: 0
        }

        this.setChange = this.setChange.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
    }

    isValidStartDate = (date) => {
        if (!date) return false;

        const mDate = moment(date.$d || date);
        const yesterday = moment().subtract(1, 'day');
        const minDate = moment().subtract(1, 'day').subtract(3, 'months');

        return !(
            mDate.isSame(moment(), 'day') ||
            mDate.isAfter(moment(), 'day') ||
            mDate.isAfter(yesterday, 'day') ||
            mDate.isBefore(minDate, 'day')
        );
    }

    isValidEndDate = (date) => {
        if (!date) return false;

        const mDate = moment(date.$d || date);
        const today = moment();

        return !mDate.isAfter(today, 'day');
    }

    getLoginInfo = () => {

        if (
            !this.isValidStartDate(this.state.filterCreatedAtStart) ||
            !this.isValidEndDate(this.state.filterCreatedAtEnd)
        ) {
            this.props.warningNotify('Date non valide → ricerca bloccata');
            return;
        }

        const yesterday = moment().subtract(1, 'day');

        let params = {
            page: this.state.changeNumberPage ? this.state.currentNumberPage : 1,
            elementsByPage: this.state.numberDevice,
            sortField: this.state.fieldOrder,
            sortType: this.state.typeOrder,

            DateStart: this.state.filterCreatedAtStart
                ? setHour(moment(this.state.filterCreatedAtStart.$d).toDate())
                : setHour(yesterday.toDate()),

            DateEnd: this.state.filterCreatedAtEnd
                ? setHour(moment(this.state.filterCreatedAtEnd.$d).toDate())
                : setHour(yesterday.toDate()),

            MinUa: this.state.filterMinUa,
            MinIp: this.state.filterMinIp,
            MinDevices: this.state.filterMinDevices,
            Src: this.state.filterText.trim()
        };

        setTimeout(() => {
            this.props.getLoginInfo(params);
        }, 500);

        if (!this.state.changeNumberPage) {
            this.setState({
                currentNumberPage: 1
            });
        }

        if (this.state.changeNumberPage) {
            this.setState({
                changeNumberPage: false,
            });
        }
    }

    setChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });

        if (event.target.name === 'numberDevice' || event.target.name === 'typeOrder') {
            setTimeout(() => {
                this.getLoginInfo();
            }, 200);
        }
    }

    setChangePagination = (event, page) => {
        if (isUndefined(page) && this.props.player.hasNext) {
            this.setState((prevState, props) => ({
                newTotalPages: prevState.currentNumberPage + 1,
                currentNumberPage: prevState.currentNumberPage + 1,
                changeNumberPage: true,
                moreItems: true
            }));

        } else if (event.target.name === '' || event.target.name === undefined) {
            this.setState({
                currentNumberPage: page,
                changeNumberPage: true
            });
        }

        setTimeout(() => {
            this.getLoginInfo();
        }, 200);
    }

    setNumberDeviceForSearch = (number) => {
        this.setState({ numberDevice: number });

        setTimeout(() => {
            this.getLoginInfo();
        }, 200);
    }

    setCreatedAtStart = (newDate) => {
        this.setState({ filterCreatedAtStart: isNull(newDate) ? null : dayjs(newDate.$d) });
    }

    setCreatedAtEnd = (newDate) => {
        this.setState({ filterCreatedAtEnd: isNull(newDate) ? null : dayjs(newDate.$d) });
    }

    clickEnter = (event) => {
        if (event.keyCode === 13) {
            this.getLoginInfo();
        }
    }

    resetFilter = () => {
        this.setState({
            filterText: '',
            filterCreatedAtStart: dayjs(moment().subtract(1, 'day').toDate()),
            filterCreatedAtEnd: dayjs(moment().toDate()),
            filterMinUa: 1,
            filterMinIp: 1,
            filterMinDevices: 5,
            numberDevice: '25',
            currentNumberPage: '1',
            fieldOrder: '',
            typeOrder: '',
        });

        setTimeout(() => {
            this.getLoginInfo();
        }, 300);
    }

    toggleModal = () => {
        this.setState(prevState => ({ modal: !prevState.modal }));
    }

    render() {
        const { player } = this.props;

        return (
            <Fragment>
                {player.isLoading && <Loading />}

                <div className="row itemForSearch">
                    <div className="col-12">
                        <TextField
                            name="filterText"
                            variant='standard'
                            value={this.state.filterText}
                            onChange={this.setChange}
                            onKeyDown={this.clickEnter}
                            label="Inserisci testo"
                        />
                    </div>
                </div>

                <div className="row itemForSearch">
                    <div className="col-12">
                        <TextField
                            name="filterMinUa"
                            variant='standard'
                            value={this.state.filterMinUa}
                            onChange={this.setChange}
                            onKeyDown={this.clickEnter}
                            label="Valore minimo di User Agent"
                        />
                    </div>
                </div>

                <div className="row itemForSearch">
                    <div className="col-12">
                        <TextField
                            name="filterMinIp"
                            variant='standard'
                            value={this.state.filterMinIp}
                            onChange={this.setChange}
                            onKeyDown={this.clickEnter}
                            label="Valore minimo di ip"
                        />
                    </div>
                </div>

                <div className="row itemForSearch">
                    <div className="col-12">
                        <TextField
                            name="filterMinDevices"
                            variant='standard'
                            value={this.state.filterMinDevices}
                            onChange={this.setChange}
                            onKeyDown={this.clickEnter}
                            label="Valore minimo di dispositivi"
                        />
                    </div>
                </div>

                <div className="row">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <div className="col-12 itemForSearch">
                            <DatePicker
                                id="filterCreatedAtStart"
                                variant="inline"
                                label="Cerca da"
                                name="filterCreatedAtStart"
                                value={this.state.filterCreatedAtStart}
                                onChange={(newValue) => this.setCreatedAtStart(isNull(newValue) ? null : dayjs(newValue.$d))}
                                shouldDisableDate={(date) => {
                                    const mDate = moment(date.$d);
                                    const yesterday = moment().subtract(1, 'day');
                                    const minDate = moment().subtract(1, 'day').subtract(3, 'months');

                                    return (
                                        mDate.isSame(moment(), 'day') ||
                                        mDate.isAfter(moment(), 'day') ||
                                        mDate.isAfter(yesterday, 'day') ||
                                        mDate.isBefore(minDate, 'day')
                                    );
                                }}
                                format="DD/MM/YYYY"
                            />
                        </div>

                        <div className="col-12 itemForSearch">
                            <DatePicker
                                id="filterCreatedAtEnd"
                                variant="inline"
                                label="Fino a"
                                name="filterCreatedAtEnd"
                                value={this.state.filterCreatedAtEnd}
                                onChange={(newValue) => this.setCreatedAtEnd(isNull(newValue) ? null : dayjs(newValue.$d))}
                                shouldDisableDate={(date) => {
                                    const mDate = moment(date.$d);
                                    const today = moment();

                                    return (
                                        mDate.isAfter(today, 'day')
                                    );
                                }}
                                format="DD/MM/YYYY"
                            />
                        </div>
                    </LocalizationProvider>
                </div>

                <div className="row">
                    <div className="col-12 itemForSearch">
                        <FormControl className='customSelect'>
                            <InputLabel>Come vuoi ordinare?</InputLabel>
                            <Select
                                labelId="fieldOrderDeviceAccessLabel"
                                name="fieldOrder"
                                variant='standard'
                                value={this.state.fieldOrder}
                                onChange={this.setChange}
                            >
                                <MenuItem value={'lastAccess'}>Ultimo Accesso</MenuItem>
                                <MenuItem value={'countUas'}>Numero User Agent</MenuItem>
                                <MenuItem value={'countIps'}>Numero Ip</MenuItem>
                                <MenuItem value={'countRequests'}>Numero Richieste</MenuItem>
                            </Select>
                        </FormControl>
                    </div>

                    <div className="col-12 itemForSearch">
                        <FormControl disabled={this.state.fieldOrder === ''} className='customSelect'>
                            <InputLabel>Tipo di Ordinamento</InputLabel>
                            <Select
                                labelId="typeOrderLabel"
                                name="typeOrder"
                                variant='standard'
                                value={this.state.typeOrder}
                                onChange={this.setChange}
                            >
                                <MenuItem value={'Asc'}>Crescente [A-Z]</MenuItem>
                                <MenuItem value={'Desc'}>Decrescente [Z-A]</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                </div>

                <div className="row itemForSearch">
                    <div className="col-12 text-center">
                        <button
                            className={this.state.numberDevice === '10' ? "btnAround selected" : "btnAround"}
                            onClick={() => { this.setNumberDeviceForSearch('10'); this.setState({ moreItems: false, newTotalPages: 0, currentNumberPage: 1 }) }}
                        > 10 </button>
                        <button
                            className={this.state.numberDevice === '25' ? "btnAround selected" : "btnAround"}
                            onClick={() => { this.setNumberDeviceForSearch('25'); this.setState({ moreItems: false, newTotalPages: 0, currentNumberPage: 1 }) }}
                        > 25 </button>
                        <button
                            className={this.state.numberDevice === '50' ? "btnAround selected" : "btnAround"}
                            onClick={() => { this.setNumberDeviceForSearch('50'); this.setState({ moreItems: false, newTotalPages: 0, currentNumberPage: 1 }) }}
                        > 50 </button>
                    </div>
                </div>

                <div className="row itemForSearch justify-content-center">
                    <div className="col-12 text-center d-flex">
                        <Pagination
                            boundaryCount={2}
                            count={this.state.moreItems ? parseInt(this.state.newTotalPages) : parseInt(this.props.player.totalPages) || 0}
                            page={parseInt(this.state.currentNumberPage)}
                            onChange={this.setChangePagination}
                            color="primary"
                            showFirstButton
                            showLastButton
                            size="small"
                        />
                    </div>

                    <button
                        className="btnMoreItems"
                        onClick={this.setChangePagination}
                        disabled={isEmpty(this.props.player.paramsGetLoginDeviceListTemp) || (parseInt(this.state.currentNumberPage) < parseInt(this.props.player.totalPages)) || (parseInt(this.state.currentNumberPage) < parseInt(this.state.newTotalPages)) || !this.props.player.hasNext}
                    >Pag. Extra <i className='fas fa-chevron-circle-right'></i></button>
                </div>

                <div className="row itemForSearch">
                    <div className="col-12 text-center">
                        <button className="btn btn-primary" style={{ 'margin': '10px' }} onClick={() => this.getLoginInfo()}>
                            Cerca
                        </button>
                        <button className="btn btn-secondary" style={{ 'margin': '10px' }} onClick={this.resetFilter}>
                            Reset
                        </button>
                    </div>
                </div>
            </Fragment>
        )
    }
}